// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    export enum DesigoCCState {
  HasNoDCC = 0,
  HasUnsizedDCC = 1,
  HasSizedDCC = 2,
  HasVMSSystem = 7,
}
